
/**
 * Converst the Enum value into a value for display to the user.
 * It removes all underscores and caoatilise the first letter of 
 * all words.
 * 
 * @param {*} value 
 * @returns 
 */
const convertToSentanceCase = (value) => {
  let output = value.replaceAll("_", " ");
  output = output.replace(/\b\w/g, char => char.toUpperCase());
  return output;
}

/**
 * Hose Opertaional Status Enum
 */
export const Status = Object.freeze({
  IN_SERVICE: "in_service", 
  OUT_OF_SERVICE: "out_of_service",
  DECOMMISSIONED: "decommissioned",

  toDisplayValue: convertToSentanceCase
});

/**
 * Hose Coupling Types Enum
 */
export const Coupling = Object.freeze({
  STORZ: "Storz",
  TPI5: "5 TPI",
  TPI3: "3 TPI",
  EXTERNAL_LUG: "External Lug",
  OTHER: "Other"
});

/**
 * HOse Material Types Enum
 */
export const Material = Object.freeze({
  CANVAS: "Canvas",
  DURALINE: "Duraline",
  OTHER: "Other"
});

/**
 * HOse Material Types Enum
 */
export const TestResult = Object.freeze({
  PASSED: "Passed",
  FAILED: "Failed"
});